export const config = {
  apiKey: 'AIzaSyB89mjFrBadVttJg2Pi8r_AuiY5q8baWcA',
  authDomain: 'shopping-v2.firebaseapp.com',
  databaseURL: 'https://shopping-v2.firebaseio.com',
  projectId: 'shopping-v2',
  storageBucket: 'shopping-v2.appspot.com',
  messagingSenderId: '193395259824',
  appId: '1:193395259824:web:a4f63e75da7270712cfe75',
}
